/* ZK cart drawer — timer + tier progress bar */
(function () {
  'use strict';

  var DRAWER_SEL = '#CartDrawer';
  var STORAGE_KEY = 'zkCartTimerExpiresAt';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Timer ---------- */
  var timerInterval = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function readExpiresAt(totalSeconds) {
    var raw = null;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (_) {}
    var now = Date.now();
    var v = raw ? parseInt(raw, 10) : NaN;
    if (!v || isNaN(v) || v <= now) {
      v = now + totalSeconds * 1000;
      try { sessionStorage.setItem(STORAGE_KEY, String(v)); } catch (_) {}
    }
    return v;
  }

  function resetTimer(totalSeconds) {
    var v = Date.now() + totalSeconds * 1000;
    try { sessionStorage.setItem(STORAGE_KEY, String(v)); } catch (_) {}
    return v;
  }

  function renderTimer() {
    var display = $('[data-zk-timer-display]');
    var host = $('[data-zk-timer]');
    if (!display || !host) return;
    var totalSeconds = parseInt(host.getAttribute('data-zk-timer-seconds'), 10) || 600;
    var expiresAt = readExpiresAt(totalSeconds);
    var remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;
    display.textContent = pad(m) + ':' + pad(s);
    if (remaining <= 0) {
      resetTimer(totalSeconds);
    }
  }

  function startTimer() {
    if (timerInterval) return;
    renderTimer();
    timerInterval = setInterval(renderTimer, 1000);
  }

  /* ---------- Tiers ---------- */
  function polishRemaining(n) {
    // 1 → produkt; 2-4 → produkty; 5+ → produktów
    if (n === 1) return '1 produkt';
    if (n >= 2 && n <= 4) return n + ' produkty';
    return n + ' produktów';
  }

  function renderTiers() {
    var host = $('[data-zk-tiers]');
    if (!host) return;
    var drawer = $(DRAWER_SEL);
    if (!drawer) return;

    var t = [
      0,
      parseInt(drawer.getAttribute('data-tier1'), 10) || 1,
      parseInt(drawer.getAttribute('data-tier2'), 10) || 2,
      parseInt(drawer.getAttribute('data-tier3'), 10) || 3,
      parseInt(drawer.getAttribute('data-tier4'), 10) || 4
    ];

    // Read count from AJAX-rendered .cart__items[data-count]
    var itemsHost = drawer.querySelector('.cart__items');
    var count = itemsHost ? (parseInt(itemsHost.getAttribute('data-count'), 10) || 0) : 0;

    // Determine current tier index (0-4)
    var current = 0;
    for (var i = 1; i <= 4; i++) { if (count >= t[i]) current = i; }

    // Fill width: proportion between current tier center and next
    var fill = 0;
    if (current === 0) {
      fill = Math.max(0, Math.min(1, count / t[1])) * (100 / 4) * 0.5;
    } else if (current >= 4) {
      fill = 100;
    } else {
      var lo = t[current], hi = t[current + 1];
      var progress = hi === lo ? 1 : Math.min(1, (count - lo) / (hi - lo));
      // dots sit at 0, 25, 50, 75, 100
      var base = (current) * 25;
      fill = base + progress * 25;
    }
    var fillEl = $('[data-zk-tiers-fill]', host);
    if (fillEl) fillEl.style.width = fill + '%';

    // Dots + labels
    for (var d = 1; d <= 4; d++) {
      var dot = host.querySelector('[data-zk-dot="' + d + '"]');
      var lbl = host.querySelector('[data-zk-label="' + d + '"]');
      var on = current >= d;
      if (dot) dot.classList.toggle('is-on', on);
      if (lbl) lbl.classList.toggle('is-on', on);
    }

    // Caption
    var labels = { 1: 'Darmowa dostawa', 2: '20%', 3: '25%', 4: '30%' };
    var caption = $('[data-zk-tiers-caption]', host);
    if (!caption) return;
    if (current >= 4) {
      caption.innerHTML = '<strong>' + labels[4] + '</strong> maksymalna zniżka odblokowana!';
    } else if (current === 0) {
      var missing = t[1] - count;
      caption.innerHTML = 'Dodaj <strong>' + polishRemaining(missing) + '</strong> aby odblokować <strong>' + labels[1] + '</strong>!';
    } else {
      var missingNext = t[current + 1] - count;
      caption.innerHTML = '<strong>' + labels[current] + '</strong> odblokowane! Dodaj jeszcze <strong>' + polishRemaining(missingNext) + '</strong> aby uzyskać <strong>' + labels[current + 1] + '</strong>!';
    }
  }

  /* ---------- Compare-at total ---------- */
  function renderCompareTotal() {
    var drawer = $(DRAWER_SEL);
    if (!drawer) return;
    var compareEl = drawer.querySelector('[data-zk-compare]');
    if (!compareEl) return;
    var items = drawer.querySelectorAll('.zk-item');
    // Compare total already server-rendered on initial load;
    // On AJAX updates, hide if no strikethrough items visible.
    var anyCompare = drawer.querySelector('.zk-item__compare');
    if (!anyCompare) compareEl.style.display = 'none';
  }

  /* ---------- Observers ---------- */
  function bind() {
    startTimer();
    renderTiers();
    renderCompareTotal();

    var itemsHost = document.querySelector(DRAWER_SEL + ' [data-products]');
    if (itemsHost && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        renderTiers();
        renderCompareTotal();
      });
      mo.observe(itemsHost, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
